import React from 'react';
import { ReactComponent as FacebookIcon } from '../images/facebook.svg'
import { ReactComponent as TwitterIcon } from '../images/twitter.svg'
import { ReactComponent as InstagramIcon } from '../images/instagram.svg'
import HistoriesList from './HistoriesList';

const OrganizationView: React.FunctionComponent<any> = ({details, news}) => {
  return (
    <div className="overflow-y-auto px-2.5 md:p-6" style={{height: 'calc(100% - 120px)'}}>
      <div className="flex items-center pb-4">
        <div className="flex-1">
          <h1 className="block text-3xl font-bruno">{details.organization_name}</h1>
          <p className="block text-xs font-bold font-overpass-mono mt-1 leading-5">{details.address}</p>
        </div>
      </div>
      {(details.facebook || details.twitter || details.instagram) &&
        <div className="py-2 border-t border-b border-maf-grey mb-4">
          <div className="flex">
            <div className="flex-none">
              <div className="flex items-center justify-center my-2"> 
                {details.facebook && 
                  <a href={`https://www.facebook.com/${details.facebook}`} target="_blank" rel="noreferrer" className="mr-4">
                    <FacebookIcon />
                  </a>
                }
                { details.twitter && 
                  <a href={`https://twitter.com/${details.twitter}`} target="_blank" rel="noreferrer" className="mr-4">
                    <TwitterIcon />
                  </a>
                }
                { details.instagram && 
                  <a href={`https://instagram.com/${details.instagram}`} target="_blank" rel="noreferrer" className="mr-4">
                    <InstagramIcon />
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      }
      { details.about_your_organization && 
      <div className="mt-2 pb-4">
        <h2 className="font-bruno text-xl">About Our Work</h2>
        <p className="font-semibold font-source-sans mt-2">{details.about_your_organization}</p>
      </div>
      }
      { details.website_link && 
        <a target="_blank" href={details.website_link} className="font-overpass-mono uppercase border border-maf-yellow text-maf-yellow py-2 px-4 inline-block mb-4 text-sm">Visit Our Website</a>
      }
      {((details.featured_campaign_name && details.featured_campaign_description) || (details.featured_campaign_name_2 && details.featured_campaign_description_2)) &&
        <React.Fragment>
          <h2 className="font-bruno border-t border-maf-grey text-xl py-4">Campaigns</h2>
          <div>
          { (details.featured_campaign_name && details.featured_campaign_description) &&
            <div className="campaign p-4 border border-maf-green mb-6">
              <h3 className="font-bruno text-base mt-0 mb-2">{details.featured_campaign_name}</h3>
              <p className="font-overpass text-sm mt-0 mb-4">{details.featured_campaign_description}</p>
              { details.campaign_link && 
                <a target="_blank" href={details.campaign_link} className="font-overpass-mono uppercase border border-white text-white p-2 inline-block text-sm cursor-pointer">Read More</a>
              }
            </div>
          }
          { (details.featured_campaign_name_2 && details.featured_campaign_description_2) &&
            <div className="campaign p-4 border border-maf-blue mb-6">
              <h3 className="font-bruno text-base mt-0 mb-2">{details.featured_campaign_name_2}</h3>
              <p className="font-overpass text-sm mt-0 mb-4">{details.featured_campaign_description_2}</p>
              { details.campaign_link_2 && 
                <a target="_blank" href={details.campaign_link_2} className="font-overpass-mono uppercase border border-white text-white p-2 inline-block text-sm cursor-pointer">Read More</a>
              }
            </div>
          }
          </div>
        </React.Fragment>
      }
      { news?.length > 0 && 
        <HistoriesList data={news} />
      }
    </div>
  )
}

export default OrganizationView;